export default "__VITE_ASSET__BCZ$Rnis__"